{
  "version": 1,
  "asset_id": "796f7ab8-72e3-470f-9feb-7702cbbcee2f",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/796f7ab8-72e3-470f-9feb-7702cbbcee2f/svc-local-seo-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/796f7ab8-72e3-470f-9feb-7702cbbcee2f/svc-local-seo-640.avif",
  "original_filename": "svc-local-seo-640.avif",
  "size": 4868,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:54Z"
}
